module.exports = __webpack_public_path__ + "img/smule.1f62f48a.png";